<div class="langs-container notranslate">
    <ion-fab>

      <!-- aria-label: nombre accesible del selector (WCAG 4.1.2) — es la primera parada del Tab
           del alta. Ionic lo reenvía al <button> interno; las banderas pasan a decorativas (alt=""). -->
      <ion-fab-button edge [attr.aria-label]="('Selección de idioma' | translate) + ': ' + shortCode(displayLanguage())">
        @if (headerLangType() === 'flags') {
          <img draggable="false" [src]="'/assets/isoLangs/' + displayLanguage() + '.svg'" alt=""/>
        }
        @else {
          <!-- Modo texto: solo el subtag de idioma (pt-BR → "pt"); el código completo
               confunde y la región puede coincidir con otro país (HRS-2934) -->
          <span aria-hidden="true"> {{ shortCode(displayLanguage()) }} </span>
        }
      </ion-fab-button>

      <ion-fab-list side="bottom">
        @for(langs of languages(); track $index) {
          @if(langs.code != displayLanguage()){
            <ion-fab-button size="large" (click)="changeLanguage(langs.code)"
              [attr.aria-label]="('Cambiar idioma a' | translate) + ' ' + shortCode(langs.code)">
              <div class="fab-wrapper">
                @if(headerLangType() === 'flags'){
                  <img draggable="false" [src]="langs.img" alt="" />
                }@else {
                  <span aria-hidden="true"> {{ shortCode(langs.code) }} </span>
                }
              </div>
            </ion-fab-button>
          }
        }
        @if(!isTechMode() && !isTechEditMode() && !isRegisterMode() && !isWebApp() && showGoogleLangs()){
          <ion-fab-button size="large" (click)="changeGoogleLanguage()"
            [attr.aria-label]="'Traducir con Google' | translate">
            <img draggable="false" class="google-lang-icon" src="/assets/imgs/langs.svg" alt="" />
          </ion-fab-button>
        }
      </ion-fab-list>

    </ion-fab>
</div>
